<template>
    <div class="card-body">
        <div class="table-responsive">
            <vuetable ref="vuetable"
                api-url="/inscriptions"
                data-path="inscriptions"
                pagination-path=""
                :css="css.table"
                :fields="fields"
                :row-class="'text-nowrap'"
                :sort-order="sorting"
            >
                <div slot="index" slot-scope="props">
                    {{ props.rowData.index }}
                </div>
                <div slot="pay_at" slot-scope="props">
                    <span class="badge badge-success" v-show="props.rowData.pay_at">Pagado</span>
                    <span class="badge badge-danger" v-show="! props.rowData.pay_at">No pagado</span>
                </div>
            </vuetable>
        </div>
    </div>
</template>

<script>
    import Vuetable from 'vuetable-2'

    export default {
        data() {
            return {
                css: {
                    table: {
                        tableClass: 'table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'bi bi-chevron-up',
                        descendingIcon: 'bi bi-chevron-down',
                        handleIcon: 'bi bi-list',
                    }
                },
                sorting: [
                    {
                        field: 'created_at',
                        direction: 'asc'
                    }
                ],
                fields: [
                    {
                        icon: 'zoom icon',
                        name: 'index',
                        title: '#'
                    },
                    {
                        icon: 'zoom icon',
                        name: 'names',
                        sortField: 'names',
                        title: 'Nombres'
                    },
                    {
                        icon: 'zoom icon',
                        name: 'last_names',
                        sortField: 'last_names',
                        title: 'Apellidos'
                    },
                    {
                        icon: 'zoom icon',
                        name: 'email',
                        sortField: 'email',
                        title: 'Correo'
                    },
                    {
                        icon: 'zoom icon',
                        name: 'country',
                        sortField: 'country',
                        title: 'País'
                    },
                   {
                        icon: 'zoom icon',
                        name: 'created_at_format',
                        title: 'Fecha',
                        sortField: 'created_at'
                    },
                    {
                        icon: 'zoom icon',
                        name: 'pay_at',
                        title: 'Estado'
                    },
                ]
            }
        },
        components: {
            Vuetable
        }
    }
</script>

